var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import * as actions from '../constants'; // Initial State

var initialState = {
  byId: {},
  order: [],
  fetched: false
};
export var noAccessUserOrganisations = function noAccessUserOrganisations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case actions.NO_ACCESS_USER_ORGANISATIONS_LOAD_REQUEST:
      return _extends({}, state);

    case actions.NO_ACCESS_USER_ORGANISATIONS_LOAD_SUCCESS:
      return _extends({}, state, action.payload, {
        fetched: true
      });

    case actions.NO_ACCESS_USER_ORGANISATIONS_LOAD_FAILURE:
      return _extends({}, state, {
        fetched: true
      });

    default:
      return state;
  }
};
export var getOrganisationById = function getOrganisationById(state, props) {
  return state.auth.noAccessUserOrganisations.byId[props.match.params.mapId];
};